
import { format } from "date-fns";
import { CardHeader, CardTitle } from "@/components/ui/card";
import { Message } from "@/types/message";
import MessageAvatar from "./header/MessageAvatar";
import MessageSender from "./header/MessageSender";
import MessageStatus from "./header/MessageStatus";
import ToneBadge from "./header/ToneBadge";
import MessageStatusBadge from "./header/MessageStatusBadge";

interface MessageCardHeaderProps {
  message: Message;
  companyName: string;
}

const MessageCardHeader = ({ message, companyName = "Merchant" }: MessageCardHeaderProps) => {
  // Default company name to prevent errors
  const merchantName = companyName || "Merchant";
  
  return (
    <CardHeader className="py-3 border-b bg-secondary/10 flex-row justify-between items-center px-4">
      <div className="flex items-center space-x-3 p-0">
        <MessageAvatar 
          type={message.type} 
          merchantName={merchantName} 
        />
        
        <div>
          <CardTitle className="text-sm font-medium flex items-center flex-wrap gap-1">
            <MessageSender 
              type={message.type} 
              merchantName={merchantName} 
            />
            
            <MessageStatusBadge status={message.status} />
            
            <ToneBadge tone={message.tone} />
            
            {message.type === "seller" && message.metadata && message.metadata.refundApproved !== undefined && (
              <MessageStatus 
                refundApproved={message.metadata.refundApproved} 
                sentiment={message.metadata?.sentiment} 
              />
            )}
          </CardTitle>
        </div>
      </div>
      
      <div className="flex items-center text-xs text-muted-foreground">
        <span>{format(message.timestamp, "MMM d, h:mm a")}</span>
      </div>
    </CardHeader>
  );
};

export default MessageCardHeader;
